module.exports = __webpack_public_path__ + "media/images/customer-f193687c7f41f4780a401a3ad2a26d9c.png";